var exports = {
  "button": "Button.module__button___cTVTTH",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___cTVTTH",
  "small": "Button.module__small___cTVTTH",
  "compact": "Button.module__compact___cTVTTH",
  "superCompact": "Button.module__superCompact___cTVTTH",
  "fitContent": "Button.module__fitContent___cTVTTH",
  "fitContainer": "Button.module__fitContainer___cTVTTH",
  "square": "Button.module__square___cTVTTH",
  "primary": "Button.module__primary___cTVTTH",
  "secondary": "Button.module__secondary___cTVTTH",
  "danger": "Button.module__danger___cTVTTH",
  "inverted": "Button.module__inverted___cTVTTH",
  "invertedOutline": "Button.module__invertedOutline___cTVTTH",
  "ghost": "Button.module__ghost___cTVTTH",
  "recording": "Button.module__recording___cTVTTH",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___cTVTTH",
  "spinner": "Button.module__spinner___cTVTTH",
  "spinnerInner": "Button.module__spinnerInner___cTVTTH",
  "spinnerItem": "Button.module__spinnerItem___cTVTTH",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___cTVTTH",
  "iconWrapper": "Button.module__iconWrapper___cTVTTH",
  "spinnerWrapper": "Button.module__spinnerWrapper___cTVTTH",
  "hidden": "Button.module__hidden___cTVTTH",
  "grid": "Button.module__grid___cTVTTH",
};

__webpack_require__.r(module.exports = exports);
